import { css } from '@emotion/react'
import { CSSProperties, memo } from 'react'
import { getPriorMissMFCCrownStyles } from '../../../../utilities/colors'
import Crown from '../../../Icons/Crown'
import { palette } from '../../../styles/colors'
import layers from '../../../styles/layers'
import Container, { ContainerProps } from '../Container'

const missMfcStyles = css({
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '100%',
    display: 'flex',
    height: '100%',
    padding: 1,
    '& svg': {
        color: palette.priorMissMfcCrownIcon,
    },
})

interface PriorMissMFCBadgeProps {
    containerProps?: Partial<ContainerProps>
    priorMissMfcRank?: number
    shadow?: boolean
    styleOverrides?: CSSProperties
}

const PriorMissMFCBadge = memo((props: PriorMissMFCBadgeProps) => {
    const {
        styleOverrides = {},
        containerProps = {},
        priorMissMfcRank,
        shadow = true,
    } = props

    if (!priorMissMfcRank) {
        return null
    }

    return (
        <Container
            title="Prior Miss MFC Winner"
            {...containerProps}
            shadow={shadow}
        >
            <div
                css={missMfcStyles}
                style={{
                    boxShadow: shadow ? layers.icons : 'none',
                    ...getPriorMissMFCCrownStyles(priorMissMfcRank),
                    ...styleOverrides,
                }}
            >
                <Crown />
            </div>
        </Container>
    )
})

export default PriorMissMFCBadge
export { PriorMissMFCBadge }
